import React, { useEffect } from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { Bio } from './components/Bio';
import { Curriculum } from './components/Curriculum';
import { Pricing } from './components/Pricing';
import { TaglineBanner } from './components/TaglineBanner';
export function App() {
  useEffect(() => {
    document.title = 'Unified Success Masterclass';
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-white antialiased" data-id="element-0" data-mp="2rlf6qtz0rq3d">
      <AnnouncementBar data-id="element-1" data-mp="2mmvnx2fq2uf8" />
      <main data-id="element-2" data-mp="2mnng03a42a0r">
        <Hero data-id="element-3" data-mp="2mjpyfm36lqiz" />
        <Bio data-id="element-4" data-mp="31aqf2ee30qq7" />
        <Curriculum data-id="element-5" data-mp="31b8ka0iq2fa9" />
        <Pricing data-id="element-6" data-mp="31bs0ncsq4vm6" />
        <TaglineBanner data-id="element-7" data-mp="31c9tdzg6grpc" />
      </main>
    </div>;
}